(() => {
  const runtimeKey = '__eightFirstPersonOpinionRuntime';

  if (window[runtimeKey]) {
    window[runtimeKey].scan(document);
    return;
  }

  const controllers = new WeakMap();

  const init = (root) => {
    if (!(root instanceof HTMLElement) || controllers.has(root)) return;

    const abortController = new AbortController();
    const { signal } = abortController;
    const progress = root.querySelector('[data-opinion-progress]');
    const shareButton = root.querySelector('[data-opinion-share]');
    const shareLabel = root.querySelector('[data-opinion-share-label]');
    const shareStatus = root.querySelector('[data-opinion-share-status]');
    let progressFrame = 0;
    let resetTimer = 0;

    const updateProgress = () => {
      progressFrame = 0;
      if (!progress) return;
      const start = root.offsetTop;
      const max = Math.max(1, root.offsetHeight - window.innerHeight);
      const value = Math.min(1, Math.max(0, (window.scrollY - start) / max));
      progress.style.transform = `scaleX(${value})`;
    };

    const requestProgress = () => {
      if (progressFrame) return;
      progressFrame = window.requestAnimationFrame(updateProgress);
    };

    window.addEventListener('scroll', requestProgress, { passive: true, signal });
    window.addEventListener('resize', requestProgress, { passive: true, signal });
    updateProgress();

    shareButton?.addEventListener('click', async () => {
      const original = shareLabel?.textContent || 'Share essay';
      window.clearTimeout(resetTimer);

      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href });
        } else {
          await navigator.clipboard.writeText(window.location.href);
          if (shareLabel) shareLabel.textContent = 'Link copied';
          if (shareStatus) shareStatus.textContent = 'Article link copied.';
        }
      } catch (error) {
        if (error?.name === 'AbortError') return;
        if (shareStatus) shareStatus.textContent = 'Copy the link from your browser to share it.';
      }

      resetTimer = window.setTimeout(() => {
        if (shareLabel) shareLabel.textContent = original;
        if (shareStatus) shareStatus.textContent = '';
      }, 2200);
    }, { signal });

    controllers.set(root, () => {
      abortController.abort();
      window.cancelAnimationFrame(progressFrame);
      window.clearTimeout(resetTimer);
      controllers.delete(root);
    });
  };

  const scan = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches('[data-opinion-story]')) init(scope);
    scope.querySelectorAll?.('[data-opinion-story]').forEach(init);
  };

  const cleanup = (scope) => {
    if (!(scope instanceof Element)) return;
    const roots = scope.matches('[data-opinion-story]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-opinion-story]'));
    roots.forEach((root) => controllers.get(root)?.());
  };

  window[runtimeKey] = { scan, cleanup };
  scan(document);

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
})();
